import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LanguageService } from "../services/language.service";

import { UiService } from "../services/ui.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private uiSrv: UiService,
        private router: Router,
        private languageSrv: LanguageService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(err => {
                if(err instanceof HttpErrorResponse) {
                    this.uiSrv.loadingStateChanged.next(false);
                    this.uiSrv.routeLoadingStateChanged.next(false);

                    this.handleErrorMessage(err);

                    return throwError(err);
                }
            })
        );
    }

    private handleErrorMessage(err: HttpErrorResponse): void {
        const defaultText = `${err.status} ${err.statusText}`;

        switch(err.status) {
            case 401:
            case 403:
                this.handle403Error();
                break;
            case 400:
            case 409:
                if(err.error && err.error.error) {
                    this.handle400Error(err.error.error, err.error.error_description);
                } else {
                    this.showMessage(defaultText, false);
                }
                break;
            case 404:
                this.showMessage('main.dialogs.serverNotFound.summary');
                break;
            default:
                // redirect to error page if error status is not a known one
                this.showMessage(defaultText, false);
                this.router.navigate(['/error']);
        }
    }

    private handle403Error(): void {
        this.showMessage('auth.tokenRfFail.summary');
        const lang = this.languageSrv.getCurrentLanguageCode();
        this.router.navigate(['/' + lang]);
    }

    private handle400Error(error: string, errorDescription: string): void {
        switch(error) {
            case 'invalid_type' :
                this.showMessage('files.uploadStates.typeError.summary');
                break;
            case 'username_already_used' :
                this.showMessage('users.usersList.userExists.summary');
                break;
            default :
                this.showMessage(error, false);
        }
    }

    private showMessage(errorMessage: string, isTranslated = true): void {
        this.uiSrv.showSnackbar(errorMessage, null, 5000, isTranslated);
    }
}
